import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M8.086 1.629 7.47 3.214l-2.114 1.2-1.686-.257a1.43 1.43 0 0 0-1.428.7l-.572 1a1.43 1.43 0 0 0 .115 1.614l1.071 1.33v2.4l-1.043 1.328a1.43 1.43 0 0 0-.114 1.614l.571 1a1.43 1.43 0 0 0 1.429.7l1.686-.257 2.085 1.2.615 1.585a1.43 1.43 0 0 0 1.328.915h1.2a1.43 1.43 0 0 0 1.329-.915l.614-1.585 2.086-1.2 1.686.257a1.43 1.43 0 0 0 1.428-.7l.572-1a1.43 1.43 0 0 0-.115-1.614L17.143 11.2V8.8l1.043-1.329a1.43 1.43 0 0 0 .114-1.614l-.571-1a1.43 1.43 0 0 0-1.429-.7l-1.686.257-2.085-1.2-.615-1.585a1.43 1.43 0 0 0-1.328-.915H9.414a1.43 1.43 0 0 0-1.328.915" />
      <path d="M7.624 11.588a2.857 2.857 0 1 1 4.752-3.175 2.857 2.857 0 0 1-4.752 3.175" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineSettings;
